class LIVE {
  //创建直播
  createdRoom(t) {
      t.$request
        .createLiveRoom({
          rotate: t.selected,
          title: t.roomName,
          cover_image: t.imageUrl,
          password: t.password
        })
        .then(res => {
          console.log(res);
          if (res.error_code != 0) {
            t.$message({
              message: res.message,
              type: "warning"
            });
          } else {
            t.isToLiveLoad = true;
            let roomId = res.data.room_id;
            localStorage.roomId = roomId;
            localStorage.userid = res.data.user_id;
            localStorage.title = res.data.title;
            localStorage.nick_name = res.data.user.nickname;
            localStorage.head_image = res.data.user.avatar_url;
            localStorage.live_id  =  res.data.live_id;
          }
        });
  }
  //获取titc签名
  geTrtc_user_sig(t){
    t.$request
      .geTrtc_user_sig()
      .then(res => { 
          localStorage.userToken = res.data.user_sig;     //titc直播签名
          localStorage.sdkappid = res.data.sdk_app_id;    //Titc appid
      });
  }
  // 获取IMusersig
  getImusersig(t) {
    t.$request
      .getImUsersig()
      .then(res => {
        localStorage.usersigIM = res.data.user_sig; //IM签名
        localStorage.sdkappidImres = res.data.sdk_app_id; //Im appid
      });
  }
}

export default new LIVE()